// 登录类型
export const ACCOUNT_TYPE = 'account';
export const PHONE_TYPE = 'mobile';

// CDN
export const OSS_HOST = 'https://3vj-fe.3vjia.com';
export const studyImg = 'https://3vj-study.3vjia.com';
export const defaultImg = 'https://3vj-fe.3vjia.com/common/images/default-img.png';

// 接口环境地址
export const ENV_API_HOST = {
  prod: {
    graph: 'https://graph.3vjia.com',
    www: 'https://www.3vjia.com',
    adLink: 'https://3vj-platform.3vjia.com',
    platformapi: 'https://platformapi.3vjia.com',
    shopCenter: 'https://shopcenter.3vjia.com',
  },
  pre: {
    graph: 'https://pre-graph.3vjia.com',
    www: 'https://www.3vjia.com',
    adLink: 'https://3vj-platform.3vjia.com',
    platformapi: 'https://pre-platformapi.3vjia.com',
    shopCenter: 'https://pre-shopcenter.3vjia.com',
  },
  test: {
    graph: 'https://graph-test.3weijia.com',
    www: 'https://www-test.3weijia.com',
    adLink: 'http://test-3vj-platform.oss-cn-shenzhen-internal.aliyuncs.com',
    platformapi: 'https://platformapi-test.3weijia.com',
    shopCenter: 'https://shopcenter-test.3weijia.com',
  },
  dev: {
    graph: 'https://graph.3weijia.com',
    www: 'https://www-test.3weijia.com',
    adLink: 'http://test-3vj-platform.oss-cn-shenzhen-internal.aliyuncs.com',
    platformapi: 'https://platformapi-test.3weijia.com',
    shopCenter: 'https://shopcenter-test.3weijia.com',
  },
};

// 本地存储加密解密
export const ENCRYPT_PUBLIC_KEY = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDIzW4sQbXl30Romya7odrNWyZXQaf/+jgmOWpgef+Op/zYUbdfyJW0ncyk7h0vHoDnaLJEcEpyaj4FPWhYKInJuYZcwO3mCjR7/LnkIOILo3qKftwghaC3J/E8rGeO04mq8q1UKt2nvZ4T6WIClXHTvt9YquzqgqSBu+uHxwXOZQIDAQAB';
export const ENCRYPT_PRIVATE_KEY = 'MIICXgIBAAKBgQDIzW4sQbXl30Romya7odrNWyZXQaf/+jgmOWpgef+Op/zYUbdfyJW0ncyk7h0vHoDnaLJEcEpyaj4FPWhYKInJuYZcwO3mCjR7/LnkIOILo3qKftwghaC3J/E8rGeO04mq8q1UKt2nvZ4T6WIClXHTvt9YquzqgqSBu+uHxwXOZQIDAQABAoGBAIsxQ96vyhxHUQ9GBWppPte9CG3R2FfrpkJw6FlqGAlWT0HQG1HtJEEoZXQqjtZbybUfcPtZ73EyTj2pnIwHxcJxN4+ECb7dVgh9+py5ruZV785SjMS/NA/ppZH25bWHKp3QEMb5vCJbRPXsdTE9FfclZo6dCz3AMK9O8u6UAgqhAkEA9w6VbKtJf0AxIIVDME98m2auC7n5Gvza7ttmhrlig/O0z2IqchL8UCGR8MhRQD+//s1CfIkHFY6ZYVFsF6fWGQJBANASN69z3+qYSyz5TaUJAoOSS8Do02QH9nNg3YVfezFRiKSJ2SzujcpBnn5zqxZj+am8CZ32MJMjLPbRmDvcDC0CQQDCzBLxfhUTaq/RroGNo/7iIRH2WQqbRufxEblDXQTaedwE8Kf7DhE3tWB289tsx1dBNuLHgtu9GZTCcQrDlChxAkEAz8QxKJibUeTqxCjY+F/Ly9esnx+d3ff5hvKFoKVcHT4eJLalTrGSkhD+E6SqhTwlU/C45ausi3AHeRqHWdZ7rQJAeKPiskOpGeLdAyTpzY/K1ht8EdapeBJdasunShaw6buO7/jV8kkZfFuDII3S0mANGqdcR/S4n4pjjwc5TBFwIg==';

// 用户角色
export const USER_ROLE = {
  IDENTITY1: {
    code: '10007239',
    label: '品牌商/工厂',
  },
  IDENTITY2: {
    code: '10008215',
    label: '门店/装修公司',
  },
  IDENTITY3: {
    code: '10008216',
    label: '设计师/导购',
  },
  IDENTITY4: {
    code: '10005245',
    label: '业主',
  },
};
